


























































































































































































































































































































































































































































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { Contact } from "@/api/models/contacts/contact";
import { Component, Vue, Ref, PropSync, Watch } from 'vue-property-decorator'
import { 
  BRow, 
  BCol, 
  BModal, 
  BFormGroup, 
  BFormInput, 
  BFormDatepicker,
  BFormTextarea,
  BButton,
  BSpinner,
  BListGroup,
  BListGroupItem
} from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { DetailsUtilisateur, ShortUtilisateur } from "@/api/models/utilisateurs/utilisateur";
import { OpportuniteCreateModel, Opportunite } from "@/api/models/opportunites/opportunite";
import { Partenaire } from "@/api/models/partenaires/partenaire";
import { Fournisseur } from "@/api/models/fournisseurs/fournisseur";

@Component({
  components: {
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormInput,
    FormWizard,
    TabContent,
    ValidationObserver,
    ValidationProvider,
    SearchableVueSelect,
    BFormDatepicker,
    BFormTextarea,
    BButton,
    BSpinner,
    BListGroup,
    BListGroupItem
  }
})
export default class UpdateOpportunite extends Vue {
  @PropSync('isUpdateOpportuniteModalActive', { type: Boolean, default: false })
  isModalVisible!: boolean

  @PropSync('opportuniteId', { type: String, default: '' })
  selectedOpportuniteId!: string

  isLoading = false

  paginatedListContactsAcheteur: PaginatedList<Contact> = new PaginatedList<Contact>();
  paginatedListContactsDecisionnaire: PaginatedList<Contact> = new PaginatedList<Contact>();
  paginatedListUsers: PaginatedList<ShortUtilisateur> = new PaginatedList<ShortUtilisateur>();
  paginatedListPartenaires: PaginatedList<Partenaire> = new PaginatedList<Partenaire>();
  paginatedListFournisseurs: PaginatedList<Fournisseur> = new PaginatedList<Fournisseur>();

  listSourceOpportunites: {code: string, libelle: string}[] = []
  listTypeOpportunites: { code: string; libelle: string; }[] = [];
  listNatureOffres: { code: string; libelle: string; }[] = [];
  listTypePrestations: { code: string; libelle: string; }[] = [];
  listStatuts: { code: string; libelle: string; }[] = [];
  listRaisonsPerte: { code: string; libelle: string; }[] = [];
  listEntiteFacturation: { code: string; libelle: string; }[] = [];
  listNiveauConfiance: { code: string; libelle: string; }[] = [];
  listModelesSharepoint: { code: string; libelle: string; path: string }[] = [];

  opportunite: OpportuniteCreateModel | null = null

  @Ref('step2Validator') readonly step2Validator!: InstanceType<typeof ValidationObserver>
  @Ref('step3Validator') readonly step3Validator!: InstanceType<typeof ValidationObserver>
  @Ref('step4Validator') readonly step4Validator!: InstanceType<typeof ValidationObserver>

  async created() {
    await Promise.all([
      this.loadSourceOpportunites(),
      this.loadTypeOpportunites(),
      this.loadNatureOffre(),
      this.loadTypePrestation(),
      this.loadStatuts(),
      this.loadRaisonsPerte(),
      this.loadEntiteFacturation(),
      this.loadNiveauConfiance(),
      this.loadModelesSharepoint()
    ])
  }

  @Watch('isModalVisible')
  async onModalVisibilityChanged(newVal: boolean) {
    if (newVal && this.selectedOpportuniteId) {
      await this.loadOpportunite()
    }
  }

  @Watch('selectedOpportuniteId')
  async onOpportuniteIdChanged(newVal: string) {
    if (newVal && this.isModalVisible) {
      await this.loadOpportunite()
    }
  }

  async loadOpportunite() {
    if (!this.selectedOpportuniteId) return

    this.isLoading = true
    try {
      const response: Opportunite = await this.$http.myressif.entreprises.getOpportuniteById(
        this.$route.params.id,
        this.selectedOpportuniteId
      )
      
      if (response.acheteurId && response.acheteurCompleteNom) {
        const acheteurExists = this.paginatedListContactsAcheteur.items.some(c => c.id === response.acheteurId)
        if (!acheteurExists) {
          this.paginatedListContactsAcheteur.items.unshift({
            id: response.acheteurId,
            completeNom: response.acheteurCompleteNom
          })
          this.paginatedListContactsAcheteur.totalCount++
        }
      }

      if (response.decisionnaireId && response.decisionnaireCompleteNom) {
        const decisionnaireExists = this.paginatedListContactsDecisionnaire.items.some(c => c.id === response.decisionnaireId)
        if (!decisionnaireExists) {
          this.paginatedListContactsDecisionnaire.items.unshift({
            id: response.decisionnaireId,
            completeNom: response.decisionnaireCompleteNom
          } as Contact)
          this.paginatedListContactsDecisionnaire.totalCount++
        }
      }

      if (response.partenaireId && response.partenaireNom) {
        const partenaireExists = this.paginatedListPartenaires.items.some(c => c.id === response.partenaireId)
        if (!partenaireExists) {
          this.paginatedListPartenaires.items.unshift({
            id: response.partenaireId,
            nom: response.partenaireNom
          } as Partenaire)
          this.paginatedListPartenaires.totalCount++
        }
      }

      if (response.fournisseurId && response.fournisseurNom) {
        const fournisseurExists = this.paginatedListFournisseurs.items.some(c => c.id === response.fournisseurId)
        if (!fournisseurExists) {
          this.paginatedListFournisseurs.items.unshift({
            id: response.fournisseurId,
            nom: response.fournisseurNom
          } as Fournisseur)
          this.paginatedListFournisseurs.totalCount++
        }
      }

      if (response.responsableId && response.responsableCompleteNom) {
        const responsableExists = this.paginatedListUsers.items.some(u => u.id === response.responsableId)
        if (!responsableExists) {
          const nameParts = response.responsableCompleteNom.split(' ')
          const nom = nameParts[0] || ''
          const prenom = nameParts.slice(1).join(' ') || ''
          
          this.paginatedListUsers.items.unshift({
            id: response.responsableId,
            nom: nom,
            prenom: prenom,
            completeLabel: response.responsableCompleteNom
          } as any)
          this.paginatedListUsers.totalCount++
        }
      }
      
      this.opportunite = response as OpportuniteCreateModel

      if (response.opportuniteId) {
        (this.opportunite as any).opportuniteId = response.opportuniteId
      }
    } catch (error: any) {
      errorAlert.fire({
        text: error?.response?.data?.detail ?? error.message ?? "Erreur lors du chargement de l'opportunité",
      })
      this.isModalVisible = false
    } finally {
      this.isLoading = false
    }
  }

  async loadListContact(params: any): Promise<PaginatedList<Contact>> {
    var response = new PaginatedList<Contact>();
    await this.$http.myressif.entreprises
      .getListContactsByEntrepriseId(
        this.$route.params.id,
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy,
        params?.orderByDescending,
        params?.search ?? ""
      )
      .then((res: PaginatedList<Contact>) => {
        response = res;
      });

      return response;
  }

  async loadListContactAcheteur(params: any) {
    if (!params || params?.reset) {
      this.paginatedListContactsAcheteur = new PaginatedList<Contact>();
    }

    var response = await this.loadListContact(params);

    this.paginatedListContactsAcheteur.items = this.paginatedListContactsAcheteur!.items.concat(
      response.items.filter(
        (ri) => !this.paginatedListContactsAcheteur!.items.some((lsi) => lsi.id == ri.id)
      )
    );
    this.paginatedListContactsAcheteur.hasNextPage = response.hasNextPage
    this.paginatedListContactsAcheteur.hasPreviousPage = response.hasPreviousPage
    this.paginatedListContactsAcheteur.pageIndex = response.pageIndex
    this.paginatedListContactsAcheteur.totalCount = response.totalCount
    this.paginatedListContactsAcheteur.totalPages = response.totalPages
  }

  async loadListContactDecisionnaire(params: any) {
    if (!params || params?.reset) {
      this.paginatedListContactsDecisionnaire = new PaginatedList<Contact>();
    }

    var response = await this.loadListContact(params);

    this.paginatedListContactsDecisionnaire.items = this.paginatedListContactsDecisionnaire!.items.concat(
      response.items.filter(
        (ri) => !this.paginatedListContactsDecisionnaire!.items.some((lsi) => lsi.id == ri.id)
      )
    );
    this.paginatedListContactsDecisionnaire.hasNextPage = response.hasNextPage
    this.paginatedListContactsDecisionnaire.hasPreviousPage = response.hasPreviousPage
    this.paginatedListContactsDecisionnaire.pageIndex = response.pageIndex
    this.paginatedListContactsDecisionnaire.totalCount = response.totalCount
    this.paginatedListContactsDecisionnaire.totalPages = response.totalPages
  }

  async loadUsers(params: any) {
    if (!params || params?.reset) {
      this.paginatedListUsers.items = this.paginatedListUsers?.items.filter(u => this.opportunite?.responsableId === u.id);
      this.paginatedListUsers.totalCount = this.paginatedListUsers.items.length;
    }

    await this.$http.myressif.utilisateurs
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.search ?? "",
        params?.hiddenUser ?? false,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
      )
      .then((response: PaginatedList<DetailsUtilisateur>) => {
        this.paginatedListUsers.items = this.paginatedListUsers!.items.concat(
            response.items.filter(
              (ri) => !this.paginatedListUsers!.items.some((lsi) => lsi.id == ri.id)
            )
          ).map((x: ShortUtilisateur) => <DetailsUtilisateur>{
          ...x,
          completeLabel: `${x.nom} ${x.prenom}`
        });
        this.paginatedListUsers.hasNextPage = response.hasNextPage
        this.paginatedListUsers.hasPreviousPage = response.hasPreviousPage
        this.paginatedListUsers.pageIndex = response.pageIndex
        this.paginatedListUsers.totalCount = response.totalCount
        this.paginatedListUsers.totalPages = response.totalPages
      });
  }

  async loadListPartenaires(params: any) {
    if (!params || params?.reset) {
      this.paginatedListPartenaires.items = this.paginatedListPartenaires?.items.filter(u => this.opportunite?.partenaireId === u.id);
      this.paginatedListPartenaires.totalCount = this.paginatedListPartenaires.items.length;
    }

    await this.$http.myressif.partenaires
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
        params?.search ?? "",
        params?.hiddenUser ?? false,
      )
      .then((response: PaginatedList<Partenaire>) => {
        this.paginatedListPartenaires.items = this.paginatedListPartenaires!.items.concat(
            response.items.filter(
              (ri) => !this.paginatedListPartenaires!.items.some((lsi) => lsi.id == ri.id)
            )
          );
        this.paginatedListPartenaires.hasNextPage = response.hasNextPage
        this.paginatedListPartenaires.hasPreviousPage = response.hasPreviousPage
        this.paginatedListPartenaires.pageIndex = response.pageIndex
        this.paginatedListPartenaires.totalCount = response.totalCount
        this.paginatedListPartenaires.totalPages = response.totalPages
      });
  }

  async loadListFournisseurs(params: any) {
    if (!params || params?.reset) {
      this.paginatedListFournisseurs.items = this.paginatedListFournisseurs?.items.filter(u => this.opportunite?.fournisseurId === u.id);
      this.paginatedListFournisseurs.totalCount = this.paginatedListFournisseurs.items.length;
    }

    await this.$http.myressif.fournisseurs
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
        params?.search ?? "",
        params?.hiddenUser ?? false,
      )
      .then((response: PaginatedList<Fournisseur>) => {
        this.paginatedListFournisseurs.items = this.paginatedListFournisseurs!.items.concat(
            response.items.filter(
              (ri) => !this.paginatedListFournisseurs!.items.some((lsi) => lsi.id == ri.id)
            )
          );
        this.paginatedListFournisseurs.hasNextPage = response.hasNextPage
        this.paginatedListFournisseurs.hasPreviousPage = response.hasPreviousPage
        this.paginatedListFournisseurs.pageIndex = response.pageIndex
        this.paginatedListFournisseurs.totalCount = response.totalCount
        this.paginatedListFournisseurs.totalPages = response.totalPages
      });
  }

  async loadParametre(parametre: string): Promise<{code: string, libelle: string, path: string}[]> {
    var response: {code: string, libelle: string, path: string}[] = []
    await this.$http.myressif.parametres
      .getByNom(parametre)
      .then((res: {valeur: string}) => {
        response = res ? JSON.parse(res.valeur) : [];
      }),
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      };

      return response;
  }

  // paramètres
  async loadSourceOpportunites() {
    this.listSourceOpportunites = await this.loadParametre('opportunites_source_opportunite')
  }

  async loadTypeOpportunites() {
    this.listTypeOpportunites = await this.loadParametre('opportunites_type_opportunite')
  }

  async loadNatureOffre() {
    this.listNatureOffres = await this.loadParametre('opportunites_nature_offre')
  }

  async loadTypePrestation() {
    this.listTypePrestations = await this.loadParametre('opportunites_type_prestation')
  }

  async loadStatuts() {
    this.listStatuts = await this.loadParametre('opportunites_statut')
  }

  async loadRaisonsPerte() {
    this.listRaisonsPerte = await this.loadParametre('opportunites_raison_perte')
  }

  async loadEntiteFacturation() {
    this.listEntiteFacturation = await this.loadParametre('opportunites_entite_facturation')
  }

  async loadNiveauConfiance() {
    this.listNiveauConfiance = await this.loadParametre('opportunites_niveau_confiance')
  }

  async loadModelesSharepoint() {
    this.listModelesSharepoint = await this.loadParametre('opportunites_modeles_sharepoint')
  }

  // Validation de l'étape 2
  validateStep2(): Promise<boolean> {
    return new Promise((resolve) => {
      this.step2Validator.validate().then((success) => {
        if (success) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }

  // Validation de l'étape 3
  validateStep3(): Promise<boolean> {
    return new Promise((resolve) => {
      this.step3Validator.validate().then((success) => {
        if (success) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }

  // Validation de l'étape 4
  validateStep4(): Promise<boolean> {
    return new Promise((resolve) => {
      this.step4Validator.validate().then((success) => {
        if (success) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }

  async onComplete() {
    if (!this.opportunite) return

    await this.$http.myressif.entreprises
      .updateOpportuniteEntreprise(
        this.$route.params.id,
        this.selectedOpportuniteId,
        this.opportunite
      )
      .then(
        async (response: string) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification d'une opportunité",
            text: "Opportunité modifiée avec succès",
          });
          this.opportunite = null
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      );
    this.isModalVisible = false
    this.$emit('refetch-data')
  }

  refreshContacts() {
    this.loadListContactAcheteur({ reset: true, pageNumber: 1, pageSize: 10 })
    this.loadListContactDecisionnaire({ reset: true, pageNumber: 1, pageSize: 10 })
  }

  openLink(url: string) {
    window.open(url, '_blank');
  }
}
